import { useEffect } from 'react';

export function useSetTitle(title: string | null) {
  useEffect(() => {
    if (title === null) return;

    const prevTitle = document.title;
    document.title = title || 'Glynt';
    return () => {
      document.title = prevTitle;
    };
  });
}
